export const SET_IDEAL_POSITION = "SET_IDEAL_POSITION";
export const RESET_IDEAL_POSITION = "RESET_IDEAL_POSITION";
export const SET_CANCEL_DATA = "SET_CANCEL_DATA";